import { NotificationData, notifications } from '@mantine/notifications';
import { variants } from '@uag/react-core';

export const loadingNotificationTemplate = {
    loading: true,
    autoClose: false,
    withCloseButton: false,
    variant: variants.notification.toastNotificationInformation
};

export const successNotificationTemplate = {
    variant: variants.notification.toastNotificationSuccess
};

export const errorNotificationTemplate = {
    variant: variants.notification.toastNotificationAlert
};

export const loadingNotification = (props: NotificationData & { id: string }) => {
    notifications.show({ ...loadingNotificationTemplate, ...props });
};

export const hideNotification = (id: string) => {
    notifications.hide(id);
};

export const successNotification = (props: NotificationData) => {
    notifications.show({ ...successNotificationTemplate, ...props });
};

export const errorNotification = (props: NotificationData) => {
    notifications.show({ ...errorNotificationTemplate, ...props });
};
